import { api } from '@/services'

export function findAllSteps(hostId) {
  return api.get(`/admin/hostOnboarding/findAll/${hostId}`)
}
export function findHostCurrentOnboardingStep(id) {
  return api.get(`/admin/hostOnboarding/findCurrentOnboardingStepData/${id}`)
}

export function findBackgroundCheck(id) {
  return api.get(`/admin/hostOnboarding/backgroundCheckDetails/${id}`)
}

export function createBackgroundCheck(id) {
  return api.post(`/admin/hostOnboarding/backgroundCheck/${id}`)
}

export function addFeedbackMessage(request) {
  return api.post(`/admin/hostOnboarding/addFeedbackMessage`, request)
}

export function nextHostOnboardingStep(hostId) {
  return api.post(`/admin/hostOnboarding/nextStep/${hostId}`)
}

export function changeHostOnboardingStep(request) {
  return api.post('/admin/hostOnboarding/changeHostStep', request)
}

export function disapproveHostOnboarding(request) {
  return api.post('/admin/hostOnboarding/disapprove', request)
}

export function changeCoursePercentage(request) {
  return api.post('/admin/hostOnboarding/changeCoursePercentage', request)
}

export function fetchDisapproveTypes() {
  return api.get('/admin/hostOnboarding/fetchDisapproveTypes')
}

export function fetchHostOnboardingStepTypes() {
  return api.get('/admin/hostOnboarding/fetchStepTypes')
}

export function fetchHostOnboardingCoursePercentages() {
  return api.get('/admin/hostOnboarding/fetchCoursePercentages')
}

export function readHostOnboardingStepFiles(hostId) {
  return api.post(`/admin/hostOnboarding/readFiles/${hostId}`)
}